import React from "react";

const Loader = () => {
  return (
    <div
      className="flex justify-center items-center p-3 h-full"
    >
      <div
        className="animate-spin inline-block w-12 h-12 border-[4px] border-current border-t-transparent text-green-600 rounded-full"
        role="status"
        aria-label="loading"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
